<script lang="ts">
  import ResolvedUnknownValueType from '$shared/atoms/ResolvedUnknownValueType/ResolvedUnknownValueType.svelte';

  interface Props {
    value?: string;
    reviewLabel?: string;
    onevent?: (payload: { type: 'click-edit' }) => void;
  }

  let { value = '', reviewLabel = '', onevent }: Props = $props();

  const onClickEdit = (): void => {
    onevent?.({ type: 'click-edit' });
  };
</script>

<div class="caqh-resolved-value">
  <div class="value">{value}</div>
  <ResolvedUnknownValueType label={reviewLabel} onclickedit={onClickEdit} />
</div>

<style>
  .value {
    margin-bottom: 8px;
  }
</style>
